import { memo, useRef, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import BaseModal from 'components/Modal/BaseModal'
import {
  DropzoneModalContainer,
  DropzoneModalTitle,
} from 'components/Modal/DropzoneModal/styles'
import { H3 } from 'components/Typography/Headings'
import HomeConfigDropZone from './HomeConfigDropZone'
import { homeConfigurationMessages } from '../../messages'
import {
  HomeConfigButtonContainer,
  HomeConfigUploadedIcon,
  HomeConfigUploadedSuccessContainer,
  HomeConfigUploadedSuccessFilenameWrapper,
  HomeConfigUploadedSuccessFilename,
  HomeConfigUploadedSuccessTitle,
} from '../styles'
import { CommonButton } from 'components/Button'
import { mdiCheckCircleOutline } from '@mdi/js'
import { useAppSelector } from 'app/hooks'
import { selectedHomeSelector } from 'features/home/selectors'

interface HomeConfigUploadModalProps {
  isOpen: boolean
  handleClose: () => void
}

function HomeConfigUploadModal({
  isOpen,
  handleClose,
}: HomeConfigUploadModalProps) {
  const [isUploadingEnd, setIsUploadingEnd] = useState(false)
  const [configId, setConfigId] = useState<string>('')
  const uploadedFilename = useRef<string | null>(null)

  const selectedHome = useAppSelector(selectedHomeSelector.data)

  const isConfigUidMetsHomeUid = selectedHome?.uid === configId

  function setUploadedFilename(name: string) {
    uploadedFilename.current = name
  }

  function onDone() {
    handleClose()
    setIsUploadingEnd(false)
    uploadedFilename.current = null
  }

  return (
    <BaseModal isOpen={isOpen} onRequestClose={handleClose}>
      {isUploadingEnd ? (
        <DropzoneModalContainer>
          <HomeConfigUploadedSuccessContainer>
            <HomeConfigUploadedIcon path={mdiCheckCircleOutline} />
            <HomeConfigUploadedSuccessTitle>
              <FormattedMessage {...homeConfigurationMessages.successTitle} />
            </HomeConfigUploadedSuccessTitle>
          </HomeConfigUploadedSuccessContainer>
          <HomeConfigUploadedSuccessFilenameWrapper>
            {isConfigUidMetsHomeUid ? (
              <>
                <HomeConfigUploadedSuccessFilename>
                  {uploadedFilename.current}
                </HomeConfigUploadedSuccessFilename>
                <span>
                  <FormattedMessage
                    {...homeConfigurationMessages.successMessage}
                  />
                </span>
              </>
            ) : (
              <b>
                <FormattedMessage
                  {...homeConfigurationMessages.uploadNonMatch}
                />
              </b>
            )}
          </HomeConfigUploadedSuccessFilenameWrapper>
          <HomeConfigButtonContainer>
            <CommonButton variant="secondary" onClick={onDone}>
              <FormattedMessage
                {...homeConfigurationMessages.uploadDoneButton}
              />
            </CommonButton>
          </HomeConfigButtonContainer>
        </DropzoneModalContainer>
      ) : (
        <DropzoneModalContainer>
          <DropzoneModalTitle>
            <H3>
              <FormattedMessage {...homeConfigurationMessages.dropzoneTitle} />
            </H3>
          </DropzoneModalTitle>

          <HomeConfigDropZone
            setUploadedFilename={setUploadedFilename}
            setIsUploadingEnd={setIsUploadingEnd}
            setConfigId={setConfigId}
          />
        </DropzoneModalContainer>
      )}
    </BaseModal>
  )
}

export default memo(HomeConfigUploadModal)
